import React from 'react';
import PropTypes from 'prop-types';
import { FxLoadingComponent } from '../FxLoaders/FxLoadingComponent';
import { FxErrorComponent } from '../FxMessages/FxErrorComponent';

export const FxComponentWrapper = ({
  isError,
  isLoading,
  errorComponent,
  loadingComponent,
  loadedComponent,
}) => {
  if (isError) {
    return errorComponent;
  }

  if (isLoading) {
    return loadingComponent;
  }

  return loadedComponent;
};

FxComponentWrapper.propTypes = {
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  errorComponent: PropTypes.node,
  loadingComponent: PropTypes.node,
  loadedComponent: PropTypes.node.isRequired,
};

FxComponentWrapper.defaultProps = {
  isError: false,
  isLoading: false,
  errorComponent: <FxErrorComponent />,
  loadingComponent: <FxLoadingComponent />,
};
